export default function FlexRow({ style, children, ...props }) {
	return (
		<div style={{ display: "flex", ...style }} {...props}>
			{children}
		</div>
	);
}
